// material-ui
import { Typography } from '@mui/material';

// project imports
import NavGroup from './NavGroup';
import jwtDecode from 'jwt-decode';
import employeeExpenseGroup from '../../../../menu-items/employeeExpenseGroup';
import managerAdvanceGroup from '../../../../menu-items/managerAdvanceGroup';
import employeeAdvanceGroup from '../../../../menu-items/employeeAdvanceGroup';
import accountantGroup from '../../../../menu-items/accountantGroup';
import managerExpenseGroup from '../../../../menu-items/managerExpenseGroup';

import { useState, useEffect } from 'react';
import { logout } from 'apis/FieldApi';
// ==============================|| SIDEBAR MENU LIST ||============================== //
const MenuList = () => {
    const [navItems, setNavItems] = useState(<></>);

    useEffect(() => {
        sideMenuCalculator();
    }, []);

    const setInıt = () => {
        // expenseItem.children[0].children.forEach(f => f.visible = true);
    }
    const sideMenuCalculator = () => {
        setInıt();
        let menuItems = {
            items: [accountantGroup, managerExpenseGroup, managerAdvanceGroup, employeeAdvanceGroup, employeeExpenseGroup]
        }
        let decoded = jwtDecode(localStorage.getItem("serviceToken"));
        let roles = decoded.systemUserRoles?.split(',');
        let calculateMenuItems = [];
        if (roles.includes('Employee')) {
            let menus = menuItems.items.filter(
                f => f.id === 'employee-expense-group' ||
                    f.id === 'employee-advance-group'
            );
            menus.forEach(menu => {
                let isExist = calculateMenuItems.find(f => f.id == menu.id);
                if (!isExist) {
                    calculateMenuItems.push(menu);
                }
            });
        }

        if (roles.includes('Manager')) {
            let menus = menuItems.items.filter(
                f => f.id === 'manager-expense-group' ||
                    f.id === 'manager-advance-group'
            );
            menus.forEach(menu => {
                let isExist = calculateMenuItems.find(f => f.id == menu.id);
                if (!isExist) {
                    calculateMenuItems.push(menu);
                }
            });
        }
        if (roles.includes('Accountant')) {
            let menus = roles.includes('Manager') ? menuItems.items.filter(
                f => f.id === 'manager-expense-group' ||
                    f.id === 'manager-advance-group' ||
                    f.id === 'accountant-group'

            ) : menuItems.items.filter(
                f => 
                    f.id === 'employee-advance-group' ||
                    f.id === 'employee-expense-group' ||
                    f.id === 'accountant-group'

            );
            menus.forEach(menu => {
                let isExist = calculateMenuItems.find(f => f.id == menu.id);
                if (!isExist) {
                    calculateMenuItems.push(menu);
                }
            });
        }

        
        menuItems.items = calculateMenuItems;
        setNavs(menuItems);
    }

    const setNavs = (menuItems) => {
        let items = menuItems.items.map((item) => {
            switch (item.type) {
                case 'group':
                    return <NavGroup key={item.id} item={item} />;
                default:
                    return (
                        <Typography key={item.id} variant="h6" color="error" align="center">
                            Menu Items Error
                        </Typography>
                    );
            }
        });
        setNavItems(items);
    }

    const handleLogout = async () => {
        try {
            await logout();
        } catch (err) {
            console.error(err);
        }
    };

    return <>{navItems}</>;
};

export default MenuList;
